import {  useState } from "react";
import { Row, Col, Carousel, Avatar } from "antd";
import {
  ArrowRightOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import Handshake_between_professionals from "assets/Handshake_between_professionals.jpg";
import { UserAddOutlined, CarryOutOutlined, PlusSquareOutlined } from "@ant-design/icons";


const   HireEnumeratorsApp = () => {
  const [showFirstDiv, setShowFirstDiv] = useState(true);

  // const handleNext = () => {
  //   carouselRef.current?.next();
  // };

  // const handlePrevious = () => {
  //   carouselRef.current?.prev();
  // };

  const toggleDivs = () => {
    setShowFirstDiv(!showFirstDiv);
  };

  return (
    <Carousel  dots={false} >
      <>
        <section className="bg-[#EDF6F1]">
          <div className="max-w-6xl mx-auto px-4 sm:px-6 mb-10">
            <div className="pt-32 pb-12 md:pt-20 md:pb-10">

              {showFirstDiv ? (
                <div className="mt-8">
                  <div className="text-center pb-12 md:pb-16">
                    <h1 className="text-4xl md:text-6xl font-extrabold mb-4 text-primary text-left">
                      A Perfect Enumerator Exists. </h1>
                    <h1 className="text-4xl md:text-6xl font-extrabold mb-4 text-left">We Will Help You Find One.</h1>
                  </div>
                  <Row>
                    <Col xs={22} sm={22} md={8} lg={8} xl={8} >
                      <img src={Handshake_between_professionals} alt="#" className="object-cover w-full h-full" />
                    </Col>
                    <Col xs={22} sm={22} md={14} lg={14} xl={14}>
                      <div className="bg-white md:py-6 py-5 px-5 md:ps-10 md:pe-4 space-y-8 rounded-r-2xl md:mt-0 mt-4">
                        <p className="font-normal md:text-lg text-xs md:tracking-wide text-border text-justify md:leading-tight">
                          Welcome, Recruiters!
                          You’re not just filling roles—you’re building the backbone of progress. At HireEnumerators.com, we don’t find enumerators; we curate field experts who treat every data point as a building block for tomorrow’s breakthroughs.
                        </p>
                        <p className="font-normal md:text-lg text-xs md:tracking-wide text-border text-justify md:leading-tight">
                          Think of your last project. Were you confident in every handpicked team member? Or did you waste time sifting through half-hearted applications? Here’s the truth: Quality data starts with quality people. And quality people? They’re our specialty.
                        </p>
                        <p className="font-normal md:text-lg text-xs md:tracking-wide text-border text-justify md:leading-tight">
                          Our platform isn’t a database—it’s your shortcut to precision-crafted teams. We’ve already vetted for the grit, attention to detail, and ethical rigor that separate “adequate” from exceptional. No more guessing. No more compromises. Just vetted professionals ready to execute your vision with military-grade accuracy.
                        </p>
                      </div>
                    </Col>
                    <Col xs={2} sm={2} md={2} lg={2} xl={2} className="flex justify-end px-1 items-center">
                      <ArrowRightOutlined className="md:text-6xl text-3xl text-primary font-black hover:text-green-900" onClick={toggleDivs} />
                    </Col>
                  </Row>
                </div>
              ) : (
                <div>

                  <div className="mt-8 max-w-6xl ">
                    <h2 className="text-left md:text-xl text-lg mb-5" style={{ color: '#6B7280' }}> Your next hire shouldn’t just collect numbers. They should elevate them. </h2>
                    <div className="text-center pb-12 md:pb-9">
                      <h1 className="text-4xl md:text-5xl font-extrabold mb-4  text-left">
                        Hire Top Enumerators in
                        <span className="text-4xl md:text-5xl font-extrabold mb-4 text-left text-green-500"> 3 Simple Steps</span>
                      </h1>
                    </div>
                    <Row className="mb-14">
                      <Col xs={2} sm={2} md={2} lg={2} xl={2} className="flex justify-start items-center">
                        <ArrowLeftOutlined className="md:text-6xl text-4xl text-primary font-black hover:text-green-900" onClick={toggleDivs} />
                      </Col>
                      <Col xs={21} sm={21} md={21} lg={21} xl={21} className="100">
                        <div className="md:mt-10 flex flex-col gap-y-10">
                          <Row gutter={[32, 16]}>
                            {[
                              {
                                icon: <UserAddOutlined className="text-green-500" />,
                                title: "1. Register & Verify",
                                description:
                                  "Sign up for your recruiter account and complete your profile. By verifying your organization’s credentials, you build trust and attract the best enumerators ready to contribute their expertise to your projects.",
                              }, {
                                icon: <CarryOutOutlined className="text-green-500" />,
                                title: "2. Review & Hire",
                                description:
                                  "Navigate through comprehensive profiles, track incoming applications, and communicate directly with candidates. Our intuitive dashboard empowers you to select the right enumerators to bring your project to life, making your hiring process efficient and effective.",
                              }
                            ].map((step, index) => (
                              <Col key={index} xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Row gutter={2} align="top">
                                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <Avatar size={35} icon={step.icon} className="bg-green-100 border-none" />
                                  </Col>
                                  <Col xs={20} sm={20} md={20} lg={20} xl={20}>
                                    <h2 className="text-lg md:text-2xl font-semibold leading-8 mb-3 text-left">
                                      {step.title}
                                    </h2>
                                    <p className="font-normal md:text-base text-border text-justify">
                                      {step.description}
                                    </p>
                                  </Col>
                                </Row>
                              </Col>
                            ))}
                          </Row>

                          <Row gutter={[32, 32]}>
                            {[
                              {
                                title: "3. Post Your Job Listing",
                                icon: <PlusSquareOutlined className="text-green-500" />,
                                description:
                                  "Craft detailed job posts that clearly define the skills and experience you need. With our smart matching tools and precise filters, your listing reaches a wide pool of qualified enumerators—ensuring you find the perfect candidate quickly.",
                              },
                            ].map((step, index) => (
                              <Col key={index} xs={24} sm={24} md={12} lg={12} xl={12}>
                                <Row gutter={2} align="top">
                                  <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <Avatar size={35} icon={step.icon} className="bg-green-100 border-none" />
                                  </Col>
                                  <Col xs={20} sm={20} md={20} lg={20} xl={20}>
                                    <h2 className="text-lg md:text-2xl font-semibold leading-8 mb-3 text-left">
                                      {step.title}
                                    </h2>
                                    <p className="font-normal md:text-base text-border text-justify">
                                      {step.description}
                                    </p>
                                  </Col>
                                </Row>
                              </Col>
                            ))}
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="bg-primary w-[98vw] -ml-[calc((100vw-100%)/2)]">
                    <div className="max-w-6xl mx-auto">
                      <p className="md:text-lg text-md py-8 text-white text-justify px-8">
                        <span className="font-bold">Join HireEnumerators.com Today</span>
                        <br />
                        We exist to amplify your impact, connect you with projects that match your exacting standards, and ensure your skills don’t just advance your career—they elevate an entire industry.
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      </>
    </Carousel>
  );
};

export default HireEnumeratorsApp;